<template>
   <div class="c-input-avatar">
      <b-form-group
              class="c-text"
              :description="description"
              :label="label"
              :label-for="id"
              :label-cols="labelCols"
              :aria-describedby="id + '_InvalidFeedback'">
         <div class="mb-3">
            <img v-if="dataValue && dataValue.src !== undefined" :src="dataValue.src">
         </div>
         <b-alert v-show="dataValue===''&&dataProcessing===false" show variant="light">
            {{Core.Definition.getDefinition('Veuillez sélectionner une image.') }}
         </b-alert>
         <Alert :alert="dataAlert"></Alert>
         <b-button :disabled="dataProcessing" class="btn btn-sm btn-info  mr-2" :id="id">
            <i v-if="dataProcessing" class="fa fa-spin fa-spinner mr-2"></i>
            {{Core.Definition.getDefinition("Sélectionner ...")}}
         </b-button>
         <b-button @click="reset" class="btn btn-sm btn-danger">
            {{Core.Definition.getDefinition("Effacer")}}
         </b-button>
         <AvatarCropper
                 outputMime="image/png"
                 :outputOptions="outputOptions"
                 @uploading="uploading"
                 @uploaded="uploaded"
                 :upload-headers="Core.Request.getHeaders(Mantle.Config.api.auth.token, Mantle.Config.api.auth.signature, Core.Session.AuthUser.email, Core.Session.AuthUser.signature, Core.Session.subDomain, Core.Session.environmentId, Core.Session.branchId, Core.Session.Setting.getSetting('lang'))"
                 :labels="{submit: Core.Definition.getDefinition('Envoyer'), cancel: Core.Definition.getDefinition('Annuler')}"
                 :trigger="'#' + id"
                 :cropper-options="cropperOptions"
                 :upload-url="dataUploadUrl">
         </AvatarCropper>
      </b-form-group>
   </div>
</template>

<script>
   import AvatarCropper from 'vue-avatar-cropper'
   import Alert from './Alert'
   export default {
     name: 'InputAvatar',
      components: {
         AvatarCropper,
         Alert
      },
     props: {
        value: {
           type: String | Object,
           default: ''
        },
        id: {
           type: String,
           default: ''
        },
        label: {
           type: String,
           default: ''
        },
        description: {
           type: String,
           default: ''
        },
        labelCols: {
           type: Number,
           default: 0
        },
        cropperOptions: {
           type: Object,
           default: function() {
              return {
                 aspectRatio: 1,
                 autoCropArea: 1,
                 viewMode: 1,
                 movable: true,
                 zoomable: true
              }
           }
        },
        outputOptions: {
           type: Object,
           default: function() {
              return {
                 width: 200,
                 height: 200
              }
           }
        },
        uploadUrl: {
           type: String,
           default: ''
        },
        form: {
           type: Object,
           default: function () {
              return {}
           }
        }
     },
     watch: {
        value(val) {
           this.dataValue = val
        },
        dataValue(val) {
           this.$emit('input', val)
        }
     },
     mounted() {
        this.dataValue = this.value
        this.dataUploadUrl = Mantle.Config.api.url + '/file/avatar'
     },
     data: () => {
        return {
           Core: window.Core,
           Mantle: window.Mantle,
           dataValue: '',
           dataProcessing: false,
           dataAlert: {},
           dataUploadUrl: ''
        }
     },
     methods: {
        uploading() {
           this.dataAlert = {}
           this.dataProcessing = true
        },
        uploaded(response, form) {
           if (response.alert !== undefined) {
              this.dataAlert = response.alert
           } else {
              if (response.file !== undefined) {
                 this.dataValue = response.file
              }
           }
           this.dataProcessing = false
        },
        reset() {
           this.dataAlert = {}
           this.dataValue = ''
        }
     }
  }
</script>